import React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { toLocaleBrowserSettings } from 'src/i18n/numberLocale';

export type CounterProps = {
  count: number;
  variant?: 'default' | 'success' | 'error';
  ['data-testid']?: string;
};

export const Counter: React.FC<CounterProps> = ({ count, variant = 'default', ...props }) => {
  let color: TypographyProps['color'] = 'text.primary';
  if (variant === 'success') {
    color = 'green.600';
  } else if (variant === 'error') {
    color = 'red.600';
  }

  return (
    <Typography variant={'text2'} color={color} data-testid={props['data-testid']}>
      {count === 0 ? '-' : toLocaleBrowserSettings(count)}
    </Typography>
  );
};
